import React from 'react';
import { Zap } from 'lucide-react';

const Footer: React.FC = () => {
  const year = new Date().getFullYear();

  return (
    <footer className="relative z-10 border-t border-slate-800 bg-black/40 backdrop-blur-sm">
      {/* Mobile-only: 10 Free Credits badge (moved from header) */}
      <div className="md:hidden flex justify-center pt-6 pb-2">
        <div className="flex items-center gap-1.5 px-3 py-2 bg-purple-900/30 rounded-full border-2 border-purple-500/50 shadow-md shadow-purple-500/20">
          <Zap size={14} className="text-purple-400 fill-purple-400 shrink-0" />
          <span className="font-bold text-purple-200 text-xs whitespace-nowrap">10 Free Credits</span>
        </div>
      </div>
      <div className="container mx-auto px-4 py-8">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 mb-8">
          {/* Brand */}
          <div className="md:col-span-1">
            <div className="mb-3">
              <img src="/Virtual Staging Studio Logo (500 × 300 Px) - 2.png" alt="Virtual Staging Studio" className="h-16 md:h-20 w-auto object-contain object-left" />
            </div>
            <p className="text-xs text-slate-500 leading-relaxed">
              AI-powered virtual staging. Transform empty rooms into beautifully furnished spaces in minutes.
            </p>
          </div>

          {/* Product */}
          <div>
            <h4 className="text-xs font-semibold text-[#8A2BE2] uppercase tracking-wider mb-3">Product</h4>
            <ul className="space-y-2 text-xs text-slate-500">
              <li>AI Furniture Placement</li>
              <li>Style Versatility</li>
              <li>High-Res Rendering</li>
              <li>Pre-Construction Sales</li>
              <li>Virtual Renovation</li>
            </ul>
          </div>

          {/* Pricing */}
          <div>
            <h4 className="text-xs font-semibold text-[#8A2BE2] uppercase tracking-wider mb-3">Pricing</h4>
            <ul className="space-y-2 text-xs text-slate-500">
              <li className="flex items-center gap-1.5">
                <span className="w-1.5 h-1.5 bg-green-400 rounded-full" />
                10 free credits on signup
              </li>
              <li>10 free credits on signup</li>
              <li>Subscription & top-ups</li>
            </ul>
          </div>

          {/* Company */}
          <div>
            <h4 className="text-xs font-semibold text-[#8A2BE2] uppercase tracking-wider mb-3">Company</h4>
            <ul className="space-y-2 text-xs text-slate-500">
              <li>
                <a href="https://hub.rehub.studio" target="_blank" rel="noopener noreferrer" className="hover:text-[#A855F7] transition-colors">
                  ReHub Studio
                </a>
              </li>
              <li>
                <a href="https://hub.rehub.studio/#/partner" className="hover:text-[#A855F7] transition-colors">
                  Partner Programme
                </a>
              </li>
              <li>
                <a href="https://hub.rehub.studio/#/contact" className="hover:text-[#A855F7] transition-colors">
                  Contact
                </a>
              </li>
              <li>
                <a href="https://rehub.studio/terms" target="_blank" rel="noopener noreferrer" className="hover:text-[#A855F7] transition-colors">
                  Terms
                </a>
              </li>
              <li>
                <a href="https://rehub.studio/privacy" target="_blank" rel="noopener noreferrer" className="hover:text-[#A855F7] transition-colors">
                  Privacy
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="pt-6 border-t border-slate-800/50 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-[11px] text-slate-600">
            © {year} ReHub Studio. All rights reserved.
          </p>
          <div className="flex items-center gap-4 text-[11px] text-slate-600">
            <span>Part of the ReHub Suite</span>
            <span className="text-slate-700">·</span>
            <span>10 free credits on signup</span>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
